import { render, staticRenderFns } from "./RecebimentoCarteira.vue?vue&type=template&id=431e9fec&"
import script from "./RecebimentoCarteira.vue?vue&type=script&lang=js&"
export * from "./RecebimentoCarteira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports